export default __webpack_public_path__ + "static/media/CustoImage (6).85e22296.png";